import { Component, Input, OnInit } from '@angular/core';
import { NavParams } from '@ionic/angular';
import { Subject } from 'rxjs';
import { CustomerModel } from 'src/app/models/customer-model';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { GameHubControllerService } from 'src/app/services/gameHub/game-hub-controller';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { LobbyApiService } from 'src/app/services/lobby/lobby.api.service';

@Component({
  selector: 'app-last-played-games',
  templateUrl: './last-played-games.component.html',
  styleUrls: ['./last-played-games.component.scss'],
})
export class LastPlayedGamesComponent implements OnInit {
  @Input() componentType: any;
  private lobbyName: string;
  protected _recentGamesSubject: Subject<any>;
  public customer: CustomerModel;
  public lastPlayedGamesArray: any = [];
  public heading: string = '';

  constructor(
    private events: EventsService,
    private lobbyApiService: LobbyApiService,
    protected navParams: NavParams,
    private userSession: UserSessionService,
    private gameHubController: GameHubControllerService,
    public config: ConfigService,
  ) {
    this.events.subscribe('event:iosgameclosed', () => {
      setTimeout(() => {
        this.onGetLastPlayedGames();
      }, 1500)
    });
  }

  ngOnInit() {

    this.userSession.getCustomer().subscribe(
      (customer) => {
        this.customer = customer;
      }
    );

    this.heading = this.componentType == 'gallery' ? 'Recently played' : 'Recently played games'

    this.onGetLastPlayedGames();
  }

  ngOnDestroy() {
    //KP this.events.unsubscribe('event:iosgameclosed');
  }

  fetchLastPlayedGames() {
    return this.lobbyApiService.getRecent(this.lobbyName, true);
  }

  public launchCasinoGame(gameData) {
    this.events.publish("event:game:close");
    setTimeout(() => {
      if(this.checkIfLiveGame(gameData)) {
        let obj = {
          action_param: "livedealer",
          action_type: "internalnav",
          name: "Live Dealer",
        };
        this.events.publish("searchbar:keyword:click", obj);
      }else {
        this.gameHubController.launchCasinoGame(gameData);
      }
    }, 600);
  
  }

  private checkIfLiveGame = (gameData: any): Boolean =>  gameData.super_type == 'LIVE_DEALER' || gameData.vendor_name == 'evolution'? true : false;

  getLastPlayedGames() {
    this._recentGamesSubject = new Subject<any>();
    this.fetchLastPlayedGames().subscribe((data) => {
      this._recentGamesSubject.next(data);
    });
    return this._recentGamesSubject;
  }

  onGetLastPlayedGames() {
    this.getLastPlayedGames().subscribe((gameIDs) => {
      if (gameIDs.result == 1) {
        this.lastPlayedGamesArray = gameIDs.payload;
      } else {
        console.log("not connected to last played games data");
      }
    });
  }

}
